import { SaveOutlined } from '@ant-design/icons'
import { Row } from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Images from 'src/common/Images'
import { GLOBAL_CLIENT } from 'src/helpers/GlobalClient'
import { ROLE, STATUS_JOB } from 'src/helpers/constants'
import { showMessageError, showMessageSuccess } from 'src/helpers/functions'
import { useStore } from 'src/hooks'
// @ts-ignore
// import renderHTML from 'react-render-html'
/**
 * `canManagerEdit`: admin/supporter sua mo ta o moi trang thai (giong khoi seller),
 * luu rieng bang API /job/manager-update. Chi truyen o popup sua viec da ton tai,
 * khong truyen o man tao viec vi luc do chua co jobId.
 */
const JobDetailDescription = observer(({ isEditingDescription, setIsEditingDescription, canManagerEdit }: any) => {
   const { t } = useTranslation()
   const JobDetailStore = useStore('JobDetailStore')
   const JobsStore = useStore('JobsStore')
   const { jobDetail } = JobDetailStore
   const status = jobDetail?.status
   const description = jobDetail?.note
   const AuthStore = useStore('AuthStore')
   const role = AuthStore.data_role
   const [isSaving, setIsSaving] = useState(false)
   const isDirty = JobDetailStore.isFieldDirty('note')

   const handleKeyDown = (e: any) => {
      // if (e.key === 'Enter' && !e.shiftKey) {
      //    // Submit the form
      //    e.preventDefault()
      //    JobDetailStore.setJobDetailDescription(e.target.value)
      // } else if (e.key === 'Enter' && e.shiftKey) {
      //    // Add new line
      // }
   }

   const handleDescriptionChange = (e: any) => {
      if (isEditingDescription) {
         JobDetailStore.setJobDetailDescription(e.target.value)
      }
   }

   const handleManagerChange = (e: any) => {
      JobDetailStore.markFieldDirty('note')
      JobDetailStore.setJobDetailDescription(e.target.value)
   }

   const handleManagerSave = async () => {
      const note = (jobDetail?.note || '').trim()
      try {
         setIsSaving(true)
         const response = await JobDetailStore.updateJobInfoByManager(jobDetail?.id, { note })
         if (!response) return
         // Va lai dong tuong ung ngoai bang quan ly viec de khong phai tai lai trang
         JobsStore.action_patchJobRow(jobDetail?.id, { note })
         showMessageSuccess('Đã cập nhật')
      } catch (error) {
         showMessageError(error)
      } finally {
         setIsSaving(false)
      }
   }

   if (canManagerEdit) {
      return (
         <>
            <Row className="gx-flex-row gx-align-items-center gx-justify-content-between gx-mb-2 gx-mx-1" wrap={false}>
               <h4 style={{ fontSize: 14, fontWeight: 600, lineHeight: '22px', color: '#272944' }}>
                  {t(GLOBAL_CLIENT.detailDescription)}
               </h4>
               {isDirty && (
                  <div className="gx-module-logo gx-mb-2" onClick={isSaving ? undefined : handleManagerSave}>
                     <SaveOutlined style={{ color: '#272944', marginLeft: 8 }} />
                     <div
                        style={{ fontSize: 14, fontWeight: 400, lineHeight: '22px', color: '#272944', marginLeft: 8 }}
                     >
                        {t(GLOBAL_CLIENT.save)}
                     </div>
                  </div>
               )}
            </Row>
            <Row className="gx-flex-row gx-align-items-center gx-justify-content-start gx-mb-2 gx-mx-1" wrap={false}>
               <TextArea
                  className="gx-mb-2 gx-w-100"
                  bordered={true}
                  value={description}
                  autoSize
                  onChange={handleManagerChange}
                  maxLength={1000}
                  showCount
               />
            </Row>
         </>
      )
   }

   return (
      <>
         <Row className="gx-flex-row gx-align-items-center gx-justify-content-between gx-mb-2 gx-mx-1" wrap={false}>
            <h4 style={{ fontSize: 14, fontWeight: 600, lineHeight: '22px', color: '#272944' }}>
               {t(GLOBAL_CLIENT.detailDescription)}
            </h4>
            {role === ROLE.CREATOR &&
               status !== STATUS_JOB.DOING &&
               status !== STATUS_JOB.REVIEW &&
               status !== STATUS_JOB.REJECT &&
               status !== STATUS_JOB.FINISH &&
               !isEditingDescription && (
                  <div
                     className="gx-module-logo gx-mb-2"
                     onClick={() => {
                        setIsEditingDescription(true)
                     }}
                  >
                     <img style={{ color: '#272944', marginLeft: 4, height: 20 }} src={Images.ic_edit} alt="icon" />
                     <div
                        style={{ fontSize: 14, fontWeight: 400, lineHeight: '22px', color: '#272944', marginLeft: 8 }}
                     >
                        {t(GLOBAL_CLIENT.chinhsua)}
                     </div>
                  </div>
               )}
         </Row>
         <Row className="gx-flex-row gx-align-items-center gx-justify-content-start gx-mb-2 gx-mx-1" wrap={false}>
            {role === ROLE.CREATOR &&
            status !== STATUS_JOB.DOING &&
            status !== STATUS_JOB.REVIEW &&
            status !== STATUS_JOB.REJECT &&
            status !== STATUS_JOB.FINISH &&
            isEditingDescription ? (
               <>
                  <TextArea
                     className="gx-mb-2 gx-w-100"
                     bordered={true}
                     value={description}
                     autoFocus={isEditingDescription}
                     autoSize
                     onChange={handleDescriptionChange}
                     onKeyDown={handleKeyDown}
                     maxLength={1500}
                     onBlur={() => setIsEditingDescription(false)}
                     showCount
                  />
               </>
            ) : (
               <>
                  <TextArea
                     className="gx-mb-2 gx-w-100"
                     bordered={true}
                     value={description}
                     // autoFocus={isEditingDescription}
                     autoSize
                     // onChange={handleDescriptionChange}
                     // onKeyDown={handleKeyDown}
                     maxLength={1500}
                     // onBlur={() => setIsEditingDescription(false)}
                     // showCount
                  />
                  {/* <pre
                  style={{
                     fontFamily: 'InferFont',
                     fontSize: 14,
                     fontWeight: 400,
                     lineHeight: '22px',
                     color: '#272944',
                     overflow: 'hidden',
                     textOverflow: 'ellipsis',
                     display: '-webkit-box',
                     WebkitLineClamp: 10,
                     WebkitBoxOrient: 'vertical',
                     whiteSpace: 'pre-wrap'
                  }}
               >
                  {description}
               </pre> */}
                  {/* <CKEditor initData={description} /> */}
                  {/* {renderHTML(description)} */}
               </>
            )}
         </Row>
      </>
   )
})

export default JobDetailDescription
